'use strict';

angular.module('tdl.filters')
  .filter('timezoneFix', ['StorageHelper', function (StorageHelper) {
    return function (input) {
      return StorageHelper.millisToDate(parseInt(input));
    };
  }]);